import { createApp, h } from "vue";
import { createPinia } from "pinia";
import VueQrcode from "@chenfengyuan/vue-qrcode";
function createHtmlGen(options) {
  const { i18n, plugins = [] } = options;
  const pinia = createPinia();
  return {
    async getHtml(component, props) {
      const elementId = "print-container";
      const app = createApp({
        setup() {
          return () => h(component, {
            id: elementId,
            ...props
          });
        }
      });
      const rawUnmount = app.unmount.bind(app);
      app.use(pinia);
      app.use(i18n);
      app.component(String(VueQrcode.name), VueQrcode);
      for (const plugin of plugins) {
        app.use(plugin);
      }
      let html = "";
      let container = null;
      try {
        container = document.createElement("div");
        app.mount(container);
        await new Promise((resolve) => setTimeout(resolve, 100));
        html = container.innerHTML;
      } catch (error) {
        console.log(error.message);
      } finally {
        rawUnmount();
        container == null ? void 0 : container.remove();
      }
      return html;
    }
  };
}
export {
  createHtmlGen
};
//# sourceMappingURL=index57.js.map
